<template>
    <div>
        <div class="site-header" v-if="screenWidth > 768">
            <div class="search-input">
                <div class="weixin" @click="handleOld">
                    <img src="@/assets/site.png" />
                    旧版入口
                </div>
                <div class="weixin" @click="handleZhan">
                    <img src="@/assets/zhanting.png" />
                    科学家精神教育基地
                </div>
                <el-popover placement="left" trigger="hover">
                    <div class="weixin-list" style=" display: flex;gap:1rem">
                        <div class="weixin-item" style="display: flex;flex-direction: column;align-items: center;">
                            <img :src="wx_official_accounts" alt="" style="width: 5rem;height: 5rem;">
                            <span style="font-size: 0.7rem;text-align: center;">三明市农科院<br />微信公众号</span>
                        </div>
                        <div class="weixin-item" style="display: flex;flex-direction: column;align-items: center;">
                            <img :src="wx_video" alt="" style="width: 5rem;height: 5rem;">
                            <span style="font-size:0.7rem;text-align: center;">三明市农科院<br />视频号</span>
                        </div>
                    </div>
                    <div class="weixin" slot="reference">
                        <img src="@/assets/weixin.png" />
                        官方微信
                    </div>
                </el-popover>
                <el-input size="small" v-model="searchKey" placeholder="请输入关键字" class="input-with-select"
                    style="width: 20rem;">
                    <el-button type="primary" slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>
            <div class="site-header-main">
                <el-image class="site-header-logo" src="http://www.smnks.com.cn/public/smnks/images/logo.png"
                    mode="widthFix"></el-image>

                <ul class="site-header-nav">
                    <template v-for="(item, index) in menuList">
                        <li :class="activeUrl == item.link ? 'active' : ''" :key="index"
                            @click="handleRouter(item.link)">
                            {{ item.title }}
                        </li>
                    </template>

                </ul>

            </div>
        </div>
        <div class="site-header" v-if="screenWidth < 768">
            <div class="button-list">
                <div class="weixin" @click="handleOld">
                    <img src="@/assets/site.png" />
                    旧版入口
                </div>
                <div class="weixin" @click="handleZhan">
                    <img src="@/assets/zhanting.png" />
                    科学家精神教育基地
                </div>
                <el-popover placement="left" trigger="hover">
                    <div class="weixin-list" style=" display: flex;gap:1rem">
                        <div class="weixin-item" style="display: flex;flex-direction: column;align-items: center;">
                            <img :src="wx_official_accounts" alt="" style="width: 5rem;height: 5rem;">
                            <span style="font-size: 0.7rem;text-align: center;">三明市农科院<br />微信公众号</span>
                        </div>
                        <div class="weixin-item" style="display: flex;flex-direction: column;align-items: center;">
                            <img :src="wx_video" alt="" style="width: 5rem;height: 5rem;">
                            <span style="font-size:0.7rem;text-align: center;">三明市农科院<br />视频号</span>
                        </div>
                    </div>
                    <div class="weixin" slot="reference">
                        <img src="@/assets/weixin.png" />
                        官方微信
                    </div>
                </el-popover>
            </div>
            <div class="site-header-main">
                <el-image class="site-header-logo" src="http://www.smnks.com.cn/public/smnks/images/logo.png"
                    mode="widthFix"></el-image>
                <div class="search-icon">
                    <i class="iconfont icon-category" @click="drawer = true;"></i>
                </div>
            </div>
        </div>

        <el-drawer :visible.sync="drawer" direction="rtl" size="80%" withHeader>
            <div class="search-mobile-input">
                <el-input size="small" v-model="searchKey" placeholder="请搜索关键字" class="input-with-select"
                    @change="handleSearch">
                    <el-button type="primary" slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>
            <el-menu :default-active="activeUrl" active-text-color="#259f53" class="site-header-nav-menu">
                <template v-for="(item, index) in menuList">
                    <el-menu-item :index="item.link" :key="index" @click="handleRouter(item.link)">
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </el-menu>
        </el-drawer>

    </div>
</template>

<script>
import { getAppConfig } from "@/api/config";
export default {
    name: 'site-footer',
    data() {
        return {
            baseUrl: 'http://api.smnky.cn',
            activeUrl: '/',
            screenWidth: 0,
            drawer: false,
            searchKey: '',
            menuList: [
                {
                    id: 1,
                    title: '首页',
                    link: '/'
                },
                {
                    id: 2,
                    title: '单位概况',
                    link: '/unit/profile'
                },
                {
                    id: 4,
                    title: '新闻中心',
                    link: '/news'
                },
                {
                    id: 5,
                    title: '科技成果',
                    link: '/achievement'
                },
                {
                    id: 6,
                    title: '三农一线',
                    link: '/farme'
                },
                {
                    id: 7,
                    title: '创新知识库',
                    link: '/repository'
                },
                {
                    id: 3,
                    title: '党建工作',
                    link: '/party/building'
                }
            ],
            wx_official_accounts: '',
            wx_video: ''
        }
    },
    watch: {
        '$route'(to, from) {
            this.activeUrl = to.path;
        },
        immediate: true // 立即执行 watch 函数
    },
    mounted() {
        this.$nextTick(() => {
            this.activeUrl = this.$route.path
            this.getScreenChange();
            window.addEventListener('resize', () => {
                this.getScreenChange()
            })
            this.getConfig();
        })
    },
    methods: {
        getConfig() {
            getAppConfig().then(res => {
                if (res.code == 200) {
                    this.wx_official_accounts = this.baseUrl + res.data.wx_official_accounts
                    this.wx_video = this.baseUrl + res.data.wx_video
                }
            })
        },
        getScreenChange() {
            const clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
            this.screenWidth = clientWidth;
        },
        handleRouter(link) {
            if (this.activeUrl != link) {
                this.$router.push(link)
            }
            this.drawer = false;

        },
        handleSearch() {
            if (this.searchKey) {
                window.open('/search?keyName=' + this.searchKey);
                this.drawer = false;
            }
        },
        handleZhan() {
            window.open('https://www.3dnest.cn/qverse/work/5Yp6pmN0noe')
        },
        handleOld() {
            window.open('http://www.smnks.com.cn/')
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/styles/theme.scss";

.site-header {
    width: 100%;
    min-width: 75rem;
    background-color: #FFFFFF;
    box-shadow: .125rem .125rem .625rem #f2f2f2;
    padding: 0.625rem;
    padding-bottom: 0;
    margin-bottom: .1rem;

    .search-input {
        width: 75rem;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 1.25rem;

        .weixin {
            display: flex;
            align-items: center;
            font-size: 0.75rem;
            cursor: pointer;

            img {
                width: 1.25rem;
            }
        }
    }

    .site-header-main {
        width: 75rem;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 0 1.875rem;
        gap: 1rem;
        align-items: stretch;

        .site-header-logo {
            width: 40%;
        }

        .site-header-nav {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            gap: 2rem;

            li {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            li.active {
                border-bottom: .1875rem solid $theme-color;
                font-weight: bold;
                color: $theme-color;

            }
        }

        .search-icon {
            cursor: pointer;
            font-size: 1.2rem;
            color: $theme-color;
        }
    }

    .el-drawer__header {
        margin-bottom: 0 !important;
        padding: 10px 10px 0 !important;
    }

    .site-header-nav-menu {
        .el-menu-item {
            height: 3rem !important;
            line-height: 3rem !important;
        }
    }
}

@media (max-width: 768px) {
    .site-header {
        min-width: unset;
        height: unset;
        background-color: #FFFFFF;
        box-shadow: .125rem .125rem .625rem #909090;
        padding: 0rem;

        .button-list {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 1.25rem;

            .weixin {
                display: flex;
                align-items: center;
                font-size: 0.75rem;

                img {
                    width: 1rem;
                }
            }
        }



        .site-header-main {
            width: 100%;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.625rem 0.625rem 0;

            .site-header-logo {
                height: unset;
                width: 80%;
            }

            .search-icon-list {
                display: flex;
                gap: 0.625rem;
            }

            .search-icon {
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;

                i {
                    font-size: 1.5rem;
                    color: $theme-color;
                }
            }
        }
    }

    .search-mobile-input {
        padding: 0 0.5rem;
    }





}
</style>